import type { PipeTransform } from '@angular/core';
import { inject, Pipe } from '@angular/core';
import type { TimeFormat } from '../utils/time-converter';
import { addDeltaToTimeInZone } from '../utils/time-converter';
import { ServerTimeService } from '../../core/server-time.service';
import { isEmpty } from '../typeguards/is-empty';

@Pipe({ name: 'addDeltaToTimeInZone' })
export class AddDeltaToTimeInZonePipe implements PipeTransform {
  private readonly zone = inject(ServerTimeService).serverTimeZone;

  transform(isoUtc: string | null | undefined, deltaMs: number, format: TimeFormat = 'HH:mm:ss'): string {
    return isEmpty(isoUtc) ? '' : addDeltaToTimeInZone(isoUtc, deltaMs, this.zone(), format);
  }
}
